angular.module('leanlaw').factory('originationDetailPaymentsDefinition', ['$timeout', '$window', 'leanLawAuth', 'userService', 'singleRequest', 'ModalService', 'viewInvoiceService', function ($timeout, $window, leanLawAuth, userService, singleRequest, ModalService, viewInvoiceService) {
  const columns = [{
    id: 'invoice',
    label: 'Invoice',
    include: () => true
  }, {
    id: 'date',
    label: 'Payment Date',
    filter: 'dateStandard',
    include: () => true
  }, {
    id: 'amount',
    label: 'Amount',
    filter: 'amount',
    number: true,
    include: () => true
  }, {
    id: 'client',
    label: 'Client',
    include: () => true
  }, {
    id: 'collected',
    label: 'Collected',
    filter: 'amount',
    number: true,
    include: () => true
  }, {
    id: 'origination',
    label: 'Origination',
    filter: 'amount',
    number: true,
    include: () => true
  }];
  const cancel = params => {
    singleRequest.cancel(params.type);
  };
  const load = ({
    columns,
    query,
    params
  }) => {
    const {
      clientId,
      matterId
    } = params;
    query.primary = 'clients';
    query.data = 'payments';
    query.detail = 'payments';
    query.zeros = false;
    query.clientId = clientId;
    query.matterId = matterId;
    query.scope = params.userId ? 'originating' : '-originating';
    query.scopeAccount = params.userId;
    return singleRequest.apiCall('invoices').getReport(query).then(result => {
      if (!result) return undefined;
      const {
        client
      } = result.clients[0];
      return {
        rows: result.data.detail.invoicePayments.map(ip => ({
          id: ip.id,
          ip,
          values: {
            invoice: {
              value: ip.invoice.reference
            },
            date: {
              value: ip.payment.date
            },
            amount: {
              value: ip.amount
            },
            client: {
              value: client.label
            },
            collected: {
              value: ip.data.collected.servicesTotal
            },
            origination: {
              value: ip.data.origination.debit
            }
          }
        }))
      };
    });
  };
  const select = row => {
    console.log('select', row);
    // showAllocation(row.ip);
  };
  const menu = [{
    label: 'Show Invoice',
    show: () => true,
    select: row => showInvoice(row.ip.invoice)
  }, {
    label: 'Show Original Draft',
    show: () => true,
    quickbooks: false,
    select: row => showDraft(row.ip.invoice)
  }, {
    label: 'Open Invoice in QuickBooks',
    show: () => true,
    quickbooks: true,
    select: row => openInvoice(row.ip.invoice)
  }, {
    label: 'Open Payment in QuickBooks',
    show: () => true,
    quickbooks: true,
    select: row => openPayment(row.ip.payment)
  }, {
    label: 'Allocation Detail',
    show: () => true,
    quickbooks: false,
    select: row => showAllocation(row.ip)
  }];
  const structure = ({
    params,
    me
  }) => {
    return {
      sort: 'date',
      totals: {
        rows: true,
        columns: false,
        totalLabelCells: 2
      },
      showFilters: {
        dateRange: true,
        distribution: true
      },
      columns
    };
  };
  return {
    structure,
    load,
    cancel,
    select,
    menu
  };
  function showInvoice(invoice) {
    const url = `${leanLawAuth.domain}/v1/invoices/${invoice.id}/pdf`;
    $window.open(url);
  }
  function showDraft(invoice) {
    viewInvoiceService.viewInvoice(invoice, false);
  }
  function showAllocation(invoicePayment) {
    $timeout(() => {
      $(".modal-backdrop.in").remove();
      // This won't flash because the backdrop is hidden
      // This simply removes the elements so they don't stack up once
      // the body doesn't have the "show-modal-overlay" class
    }, 50);
    ModalService.showModal({
      template: require("../../../modals/allocation/template.html"),
      inputs: {
        params: {
          invoicePayment
        }
      },
      bodyClass: "show-modal-overlay",
      controller: "AllocationModalController"
    }).then(modal => {
      modal.element.modal();
      modal.close.then(() => {
        // Remove modal-open class from body which breaks print
        $("body").removeClass("modal-open");
      });
    });
  }
  async function openInvoice(invoice) {
    const me = await userService.me();
    const url = `${me.configuration.quickbooks}/app/invoice?txnId=${invoice.accounting.id}`;
    $window.open(url, '_blank');
  }
  async function openPayment(payment) {
    const me = await userService.me();
    const url = `${me.configuration.quickbooks}/app/recvpayment?txnId=${payment.accounting.id}`;
    $window.open(url, '_blank');
  }
}]);